import React from 'react';
import { string, shape } from 'prop-types';
import Img from 'gatsby-image';

const Quote = ({ imageLandscape, imagePortrait, headline, className }) => {
  return (
    <div className={`relative ${className}`}>
      {imageLandscape.childImageSharp ? (
        <Img className="hidden lg:block h-128 opacity-50 w-full" fluid={imageLandscape.childImageSharp.fluid} />
      ) : (
        <Img className="hidden lg:block h-128 opacity-50 w-full" fluid={imageLandscape.fluid} />
      )}

      {imagePortrait.childImageSharp ? (
        <Img
          className="lg:hidden h-128  w-full"
          fluid={imagePortrait.childImageSharp.fluid}
          style={{ opacity: '0.4' }}
        />
      ) : (
        <Img
          className="lg:hidden h-128  w-full"
          fluid={imagePortrait.fluid}
          style={{ opacity: '0.4' }}
          alt={imagePortrait.alt}
        />
      )}

      <div className="absolute h-full w-full top-0 left-0 flex flex-col justify-center items-center">
        <div className="container mx-auto px-4">
          <div className="leading-tight italic text-4xl pr-8 lg:w-1/2 lg:text-5xl">{`"${headline}"`}</div>
        </div>
      </div>
    </div>
  );
};

Quote.propTypes = {
  imageLandscape: shape({}),
  imagePortrait: shape({}),
  headline: string,
  className: string,
};

Quote.defaultProps = {
  imageLandscape: null,
  imagePortrait: null,
  headline: null,
  className: null,
};

export default Quote;
